import { render } from "./Slide_show_edit.vue?vue&type=template&id=35f606f2&scoped=true"
import script from "./Slide_show_edit.vue?vue&type=script&lang=js"
export * from "./Slide_show_edit.vue?vue&type=script&lang=js"

import "./Slide_show_edit.vue?vue&type=style&index=0&id=35f606f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f606f2"]])

export default __exports__